import React, { useState, useEffect, useRef, Fragment } from "react";
import Pagination from "../../shared/common/pagination";
import DeleteModal from "../../shared/common/deleteModal";
import Loader from "../../shared/loader/loader";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import { ISubjectPage } from "../../../model/interface/subject";
import Select from "react-select";
import AddSellableProduct from "../../shared/common/addSellableProduct";
import {
  getGradeAll,
  getStateAll,
  deleteSubjectAPI,
  getSubject,
  getSubjectTypes,
  createSubjectClone,
} from "../../../api/subject.service";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import {
  AddIcon,
  ApproveIcon,
  EditIcon,
  DeleteIcon,
  FilterIcon,
  ResetIcon,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
  Disapprove,
  AlertIcon,
  CopyIcon,
  CSVIcon,
} from "../../../assets/icons/index";
import constant from "../../../utils/constant";
import CloneSubjectModal from "../../shared/common/cloneSubjectModal";
import ExportToCSV from "../../shared/common/exportToCsv";
import { ISellableProduct } from "../../../model/interface/sellableProduct";
import { DotsVerticalIcon } from "@heroicons/react/solid";
import { Menu, Transition } from "@headlessui/react";
import { toast } from "react-toastify";
import MultiStateButton from "../../shared/common/multiStateButton";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { Link, useNavigate } from "react-router";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Subject: React.FC = () => {
  const defaultPageNumber = 1;
  const defaultPageSize = 100;
  const initialState = {
    name: "",
    contentAreaId: 0,
    contentAreaName: "",
    gradeId: 0,
    gradeName: "",
    stateId: 0,
    stateName: "",
    gradeLevelId: 0,
    gradeLevelName: "",
    isActive: null,
    isApproved: true,
    notes: "",
    scoringAlgorithm: "",
    subjectId: "",
  };
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [newSubject, setNewSubject] = useState<any>([]);
  const [newGrade, setNewGrade] = useState<any>([]);
  const [newState, setNewState] = useState<any>([]);
  const [newContent, setNewContent] = useState<any>([]);
  const [deleteSubject, setDeleteSubject] = useState<any>(null);
  const [filterInput, setFilterInput] = useState<any>(initialState);
  const [loading, setLoading] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortCol, setSortCol] = useState<string>("totalTestPercentage");
  const [sortByDesc, setSortByDesc] = useState<boolean>(false);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [selectedSubjectId, setSelectedSubjectId] = useState<number>();
  const [selectedSubjectName, setSelectedSubjectName] = useState<string>("");
  const [showClonePopup, setShowClonePopup] = useState<boolean>(false);
  const [selectedCloneSubjectId, setselectedCloneSubjectId] =
    useState<number>();
  const [selectedCloneSubjectName, setSelectedCloneSubjectName] =
    useState<string>("");
  const gradeLevelData = [
    {
      value: "ece",
      name: "Early Childhood Learning",
      label: "Early Childhood Learning (ece)",
    },
    { value: "elem", name: "Elementary", label: "Elementary (elem)" },
    { value: "ms", name: "Middle School", label: "Middle School (ms)" },
    { value: "hs", name: "High School", label: "High School (hs)" },
  ];
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [subjectTypes, setSubjectTypes] = useState<ISelectElement[]>([]);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const childRef: any = useRef(undefined);
  const [sellableProducts, setSellableProducts] = useState<ISellableProduct[]>(
    []
  );
  const [selectedCloneSubjectTypeId, setSelectedCloneSubjectTypeId] =
    useState<number>(0);
  const multiStateObj = [
    { label: "Alert", value: true },
    { label: "Both", value: null, selected: true },
    { label: "No Alert", value: false },
  ];
  const multiStateObjIsActive = [
    { label: "Active", value: true },
    { label: "Both", value: null, selected: true },
    { label: "Inactive", value: false },
  ];
  const [isAlert, setIsAlert] = useState<boolean | null>(null);
  const [isActive, setIsActive] = useState<boolean | undefined>(undefined);

  function handleAddProductConfirmation(confirmAction: boolean) {
    setShowConfirmation(false);
    resetClickHandler();
  }
  function handleAddProduct(subjectId: number, subjectName: string) {
    setSelectedSubjectId(subjectId);
    setSelectedSubjectName(subjectName);
    setShowConfirmation(true);
  }

  const deleteSubjectHandler = (e, id) => {
    e.preventDefault();
    setShowDeleteModal(true);
    const deleteSubject: any = newSubject.find(
      (subject: any) => subject.subjectId === id
    );
    setDeleteSubject(deleteSubject);
  };

  const deleteRecordHandler = () => {
    const recordsAfterDelete: any[] = newSubject.filter(
      (subject: any) => subject.subjectId !== deleteSubject.subjectId
    );
    if (deleteSubject.subjectId > 0) {
      deleteSubjectAPI(deleteSubject.subjectId);
      filterSubjects(false, true, true);
    }
    setShowDeleteModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const filterInputChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setFilterInput({
      ...filterInput,
      [name]: value,
    });

    if (e.target.value === "") {
      filterSubjects();
    }
  };

  const handleSortBy = (column: string) => {
    setSortByDesc(!sortByDesc);
    setSortCol(column);
  };

  const filterHandler = (e) => {
    e.preventDefault();
    filterSubjects(false, true);
  };

  useEffect(() => {
    if (isLoaded) {
      filterSubjects();
    }
  }, [sortByDesc]);

  function filterSubjects(resetObj?, onFilter?, onDelete?) {
    setLoading(true);
    if (onFilter) setIsFilter(true);

    const subjectData: ISubjectPage = {
      name: filterInput.name || "",
      contentAreaId: filterInput.contentAreaId || 0,
      stateId: filterInput.stateId || 0,
      gradeId: filterInput.gradeId || 0,
      gradeLevel: filterInput.gradeLevelId || "",
      orderbyColumn: sortCol,
      sortDir: sortByDesc ? "ASC" : "DESC",
      pageSize: onDelete ? pageSize : onFilter ? defaultPageSize : pageSize,
      pageNumber: onDelete
        ? pageNumber
        : onFilter
        ? defaultPageNumber
        : pageNumber,
      isActive: isActive,
      isApproved: filterInput.isApproved,
      subjectId: filterInput.subjectId || 0,
      subjectTypeId: filterInput.subjectTypeId,
      isAlert,
    };

    getSubject(resetObj ? resetObj : subjectData).then((response: any) => {
      setLoading(false);

      setNewSubject(response.data.data);
      setTotalPages(
        Math.ceil(
          response.data.totalRecords / (resetObj ? defaultPageSize : pageSize)
        )
      );
      setTotalRecords(response.data.totalRecords);
      if (onFilter) {
        if (!onDelete) {
          paginationRef?.current?.onReset();
          pageSizeRef?.current?.onReset();
        }

        setIsFilter(false);
      }
    });
  }

  const resetClickHandler = () => {
    setResetDropdownFlag(!resetDropdownFlag);

    setFilterInput({
      ...initialState,
    });

    filterSubjects({
      stateId: 0,
      gradeId: 0,
      contentAreaId: 0,
      pageSize: defaultPageSize,
      pageNumber: defaultPageNumber,
      orderbyColumn: "totalTestPercentage",
      sortDir: "asc",
      isApproved: true,
      subjectId: 0,
      isAlert: null,
    });
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
  };

  const updateDropdownValues = (updateObj) => {
    if (updateObj.type == "State") {
      setFilterInput({
        ...filterInput,
        stateId: updateObj.value || 0,
        stateName: updateObj.label || 0,
      });
    } else if (updateObj.type == "Grade") {
      setFilterInput({
        ...filterInput,
        gradeId: updateObj.value || 0,
        gradeName: updateObj.label || 0,
      });
    } else if (updateObj.type == "GradeLevel") {
      setFilterInput({
        ...filterInput,
        gradeLevelId: updateObj.value || "",
        gradeLevelName: updateObj.label || "",
      });
    } else if (updateObj.type == "ContentArea") {
      setFilterInput({
        ...filterInput,
        contentAreaId: updateObj.value || 0,
        contentAreaName: updateObj.label || "",
      });
    } else if (updateObj.type == "subjectType") {
      setFilterInput({
        ...filterInput,
        subjectTypeId: updateObj.value || 0,
        subjectTypeName: updateObj.label || 0,
      });
    }
  };

  const getSubjectData = async () => {
    filterSubjects();
  };

  const getStateData = async () => {
    const response = getStateAll(999, 1);
    const data = (await response).data;
    let newStateData = [];
    if (data.data.length > 0) {
      newStateData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.stateId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setNewState(newStateData);
  };

  const getGradeData = async () => {
    const response = getGradeAll(999, 1);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );
      newGradeData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId || 0,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setNewGrade(newGradeData);
  };

  const getContent = async () => {
    const service = await import("../../../api/contentArea.service");
    const response = service.getContentArea(999, 1);
    const data = (await response).data;
    setNewContent(data.data);
    let newContentData = [];
    if (data.data.length > 0) {
      newContentData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setNewContent(newContentData);
  };

  const getSubjectTypeData = () => {
    getSubjectTypes().then((types) => {
      const subjecTypes = types.data.map((_g) => {
        return {
          label: _g.name,
          value: parseInt(_g.id),
        };
      });

      setSubjectTypes(subjecTypes);
    });
  };

  useEffect(() => {
    if (isLoaded && !isFilter) {
      getSubjectTypeData();
      getSubjectData();
      getGradeData();
      getStateData();
      getContent();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1 && !isFilter) {
      getSubjectTypeData();
      getSubjectData();
      getGradeData();
      getStateData();
      getContent();
      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  function redirectToSubjectDetail(subjectId: number, subjectType: number) {
    if (subjectId) {
      navigate(constant.SUBJECTDETAIL.replace(":id", subjectId.toString()), {
        state: { subjectType },
      });
    } else {
      navigate(constant.ADDSUBJECT);
    }
  }

  function redirectToSubjectClone(subjectId: number, subjectType: number) {
    if (subjectId) {
      navigate(constant.SUBJECTDETAIL.replace(":id", subjectId.toString()), {
        state: { subjectType: Number(subjectType) },
      });
    }
  }

  function closeClonePopup() {
    setShowClonePopup(false);
  }

  function cloneSubject(subjectId: number, subjectTypeId) {
    setShowClonePopup(false);
    createSubjectClone(subjectId)
      .then((clonedSubject) => {
        redirectToSubjectClone(clonedSubject.data, subjectTypeId);
      })
      .catch((e) => {
        toast.error("Something went wrong! Please try again later");
      });
  }

  function handleCloneSubject(
    subjectId: number,
    subjectName: string,
    subjectTypeId
  ) {
    setselectedCloneSubjectId(subjectId);
    setSelectedCloneSubjectName(subjectName);
    setSelectedCloneSubjectTypeId(subjectTypeId);
    setShowClonePopup(true);
  }

  /** Code to implement input type number to support all browsers */
  useEffect(() => {
    getSubjectTypeData();
    const input = document.getElementById("subjectId");
    if (input) {
      input.addEventListener("keypress", (e: any) => {
        const keyValue = e.key;
        if (!e.target.value && e.key == 0) {
          e.preventDefault();
        } else {
          if (!/[0-9.]/.test(keyValue)) {
            e.preventDefault();
          }
        }
      });
    }
  }, []);

  const exportFn = async () => {
    setLoading(true);
    const subjectData: ISubjectPage = {
      name: filterInput.name || "",
      contentAreaId: filterInput.contentAreaId || 0,
      stateId: filterInput.stateId || 0,
      gradeId: filterInput.gradeId || 0,
      gradeLevel: filterInput.gradeLevelId || "",
      orderbyColumn: sortCol,
      sortDir: sortByDesc ? "desc" : "asc",
      pageSize: 9999,
      pageNumber: 1,
      isActive: isActive,
      isApproved: filterInput.isApproved,
      subjectId: filterInput.subjectId || 0,
      subjectTypeId: filterInput.subjectTypeId,
      isAlert,
    };

    const response = getSubject(subjectData);
    const data = (await response).data;
    setLoading(false);

    if (data && data.data && data.data.length > 0) {
      childRef?.current?.onDownload(data.data, "subjects.csv");
    } else {
      toast.warning("No records to download");
    }
  };

  return (
    <AllowedTo perform={Permissions.subject_view} no={() => <AccessDenied />}>
      {loading && <Loader />}

      {showClonePopup && (
        <CloneSubjectModal
          closeCloneModal={closeClonePopup}
          cloneSubject={cloneSubject}
          subjectName={selectedCloneSubjectName}
          subjectId={selectedCloneSubjectId}
          subjectTypeId={selectedCloneSubjectTypeId}
        />
      )}

      {showConfirmation && (
        <AddSellableProduct
          subjectId={selectedSubjectId}
          subjectName={selectedSubjectName}
          existingSellableProducts={sellableProducts}
          title={"Add Sellable Product"}
          confirmAction={handleAddProductConfirmation}
          message={"Please Select Product"}
          buttonText={"Add"}
        />
      )}

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteModal}
          deleteRecord={deleteRecordHandler}
        />
      )}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">Subject</h3>
              <AllowedTo perform={Permissions.subject_create}>
                <button
                  type="button"
                  className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transition ease-in-out duration-300"
                  onClick={(e) => {
                    redirectToSubjectDetail(0, constant.SubjectType.PL);
                  }}
                >
                  <AddIcon className="w-5"></AddIcon>
                  Add Subject
                </button>
              </AllowedTo>
            </div>

            <form action="#" onSubmit={filterHandler}>
              <div className="pt-6 border-b pb-6">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">Subject Id</label>
                    <input
                      id="subjectId"
                      name="subjectId"
                      type="number"
                      autoComplete="off"
                      className="w-full mt-1 order border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      value={filterInput.subjectId}
                      onChange={filterInputChangeHandler}
                      onWheel={(e) => e.currentTarget.blur()}
                    />
                  </div>

                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">Name</label>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      autoComplete="off"
                      className="w-full mt-1 order border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      value={filterInput.name}
                      onChange={filterInputChangeHandler}
                    />
                  </div>

                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">
                      Content Area
                    </label>
                    <Select
                      className="mt-1 text-sm"
                      value={{
                        label: filterInput.contentAreaName,
                        value: filterInput.contentAreaId,
                      }}
                      onChange={(result) =>
                        updateDropdownValues({ ...result, type: "ContentArea" })
                      }
                      options={newContent}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                    />
                  </div>

                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">State</label>
                    <Select
                      className="mt-1 text-sm"
                      value={{
                        label: filterInput.stateName,
                        value: filterInput.stateId,
                      }}
                      onChange={(result) =>
                        updateDropdownValues({ ...result, type: "State" })
                      }
                      options={newState}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                    />
                  </div>

                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">Grade</label>
                    <Select
                      className="mt-1 text-sm"
                      value={{
                        label: filterInput.gradeName,
                        value: filterInput.gradeId,
                      }}
                      onChange={(result) =>
                        updateDropdownValues({ ...result, type: "Grade" })
                      }
                      options={newGrade}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                    />
                  </div>

                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">Grade Level</label>
                    <Select
                      className="mt-1 text-sm"
                      value={{
                        label: filterInput.gradeLevelName,
                        value: filterInput.gradeLevelId,
                      }}
                      onChange={(result) =>
                        updateDropdownValues({ ...result, type: "GradeLevel" })
                      }
                      options={gradeLevelData}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-12 gap-6 mt-4">
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">
                      Subject Type
                    </label>
                    <Select
                      className="mt-1 text-sm"
                      value={{
                        label: filterInput.subjectTypeName,
                        value: filterInput.subjectTypeId,
                      }}
                      onChange={(result) =>
                        updateDropdownValues({ ...result, type: "subjectType" })
                      }
                      options={subjectTypes}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#B3B3B3",
                          primary: "#041E42",
                        },
                      })}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          background:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#1A1C23"
                              : "white",
                          borderColor:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6B7280"
                              : "#D1D5DB",
                          borderWidth: "1px",
                          "&:hover": {
                            borderColor:
                              state.isFocused &&
                              document.getElementsByClassName("dark")?.length >
                                0
                                ? "#6b7280"
                                : state.isFocused
                                ? "#4c5563"
                                : "",
                          },
                        }),
                        singleValue: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "#374051",
                        }),
                        input: (base) => ({
                          ...base,
                          color:
                            document.getElementsByClassName("dark")?.length > 0
                              ? "white"
                              : "",
                        }),
                      }}
                    />
                  </div>

                  <div className="col-span-2 flex items-center mt-6">
                    <MultiStateButton
                      labels={multiStateObj}
                      onSelect={(e) => setIsAlert(e.value)}
                      onReset={resetDropdownFlag}
                    />
                  </div>

                  <div className="col-span-2 flex items-center mt-6">
                    <MultiStateButton
                      labels={multiStateObjIsActive}
                      onSelect={(e) => setIsActive(e.value)}
                      onReset={resetDropdownFlag}
                    />
                  </div>

                  <div className="col-span-1 flex items-end">
                    <div className="flex items-center">
                      <input
                        id="isApproved"
                        name="isApproved"
                        type="checkbox"
                        className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                        onChange={filterInputChangeHandler}
                        checked={filterInput.isApproved}
                      />
                      <label className="ml-1.5 py-2 text-sm text-gray-700">
                        Approved
                      </label>
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                  <button
                    type="submit"
                    className="inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                  >
                    <FilterIcon className="w-3 h-3"></FilterIcon>
                    <span>Filter</span>
                  </button>

                  <button
                    type="button"
                    onClick={resetClickHandler}
                    className="py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  >
                    <ResetIcon className="w-3 h-3"></ResetIcon>
                    <span>Reset Filter</span>
                  </button>
                </div>
              </div>

              <div className="flex mt-4 justify-end">
                <div className="flex space-x-4 items-center dark:text-white">
                  <div className="flex items-center">
                    <span className="w-1 h-4 bg-green-500 rounded-md inline-block mr-2"></span>
                    Active
                  </div>

                  <div className="flex items-center">
                    <AlertIcon title="The subject cannot be live if the domain is not 100% " />
                    <div className="pl-2">Alert</div>
                  </div>

                  <div className="flex items-center">
                    <ApproveIcon />
                    <div className="pl-2">Approved</div>
                  </div>

                  <div className="flex items-center">
                    <span className="flex items-center justify-center inline-block w-5 h-5  rounded ring-1 ring-inset ring-purple-300 ring-opacity-0 bg-purple-700 text-white text-xs p-1">
                      PL
                    </span>
                    <div className="pl-2">Subject Type</div>
                  </div>

                  <button
                    type="button"
                    onClick={() => exportFn()}
                    className="py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  >
                    <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                    <span>Export</span>
                  </button>

                  <ExportToCSV ref={childRef} />
                </div>
              </div>
            </form>

            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2 relative  sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="px-5 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider rounded-tl-lg"
                            >
                              <span className="flex">
                                Id
                                <span className="cursor-pointer">
                                  {sortByDesc && sortCol === "subjectId" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("subjectId")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("subjectId")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Name
                                <span className="cursor-pointer">
                                  {sortByDesc && sortCol === "name" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("name")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("name")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Content Area
                                <span className="cursor-pointer">
                                  {sortByDesc && sortCol === "contentArea" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("contentArea")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("contentArea")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">
                                Grade Level
                                <span className="cursor-pointer">
                                  {sortByDesc && sortCol === "gradeLevel" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("gradeLevel")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("gradeLevel")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">Sellable Product</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 text-sm font-light tracking-wider text-center text-white whitespace-nowrap dark:text-white"
                            >
                              <span className="flex">Subject Group</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 text-sm font-light tracking-wider text-center text-white whitespace-nowrap dark:text-white"
                            >
                              <span className="flex">Scoring Algorithm</span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider rounded-tr-lg"
                            ></th>
                          </tr>
                        </thead>

                        <tbody>
                          {newSubject.map((subject, index) => (
                            <tr
                              key={index}
                              className={`align-top ${
                                index % 2 === 0 ? "bg-white " : "bg-gray-100"
                              }`}
                            >
                              <td className=" px-3 py-2  text-sm text-left font-normal relative">
                                <div className="flex">
                                  {subject.totalTestPercentage != 100 &&
                                    subject.subjectTypeId === "1" && (
                                      <AlertIcon title="The subject cannot be live if the domain is not 100% " />
                                    )}
                                  {subject.totalTestPercentage == 100 && (
                                    <span className="w-5"></span>
                                  )}
                                  {subject.isActive ? (
                                    <span className="mr-1 h-4/5 w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                  ) : (
                                    <span className="mr-1 h-4/5 w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                  )}
                                  <Link
                                    className={`ml-1 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline`}
                                    to={constant.SUBJECTDETAIL.replace(
                                      ":id",
                                      subject.subjectId.toString()
                                    )}
                                  >
                                    {subject.subjectId}
                                  </Link>
                                </div>
                              </td>

                              <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                <div className="flex items-center">
                                  <a
                                    href={constant.SUBJECTDETAIL.replace(
                                      ":id",
                                      subject.subjectId.toString()
                                    )}
                                    className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                    onClick={(e) => {
                                      redirectToSubjectDetail(
                                        subject.subjectId,
                                        parseInt(subject.subjectTypeId)
                                      );
                                    }}
                                  >
                                    {subject.name}
                                  </a>
                                </div>
                              </td>

                              <td className="px-3 py-2 capitalize text-sm font-normal text-gray-500">
                                {subject.contentAreaName}
                              </td>

                              <td className="px-3 py-2 whitespace-nowrap text-sm font-normal text-gray-500">
                                {subject.gradeLevel}
                              </td>

                              <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                {subject.sellableProducts &&
                                subject.sellableProducts.length > 0
                                  ? subject.sellableProducts.map(
                                      (product, i) => (
                                        <div key={i} className="grid">
                                          <a
                                            className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                            href={constant.MANAGESELLABLEPRODUCT.replace(
                                              ":id",
                                              product.sellableProductId.toString()
                                            )}
                                          >
                                            {product.sellableProductName}
                                          </a>
                                        </div>
                                      )
                                    )
                                  : ""}
                              </td>
                              <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                {subject.subjectGroupName
                                  ? subject.subjectGroupName
                                  : ""}
                              </td>
                              <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                {subject.scoringAlgorithm
                                  ? subject.scoringAlgorithm
                                  : ""}
                              </td>

                              <td className="flex justify-end items-center px-3 py-2 text-sm text-center font-normal text-gray-700">
                                <div className="flex justify-center items-center space-x-2">
                                  {subject.isApproved ? (
                                    <ApproveIcon />
                                  ) : (
                                    <Disapprove />
                                  )}

                                  <div>
                                    {subject.subjectTypeId == 1 ? (
                                      <span className="mt-1 w-4 h-4 flex items-center justify-center inline-block w-5 h-5  rounded ring-1 ring-inset ring-purple-300 ring-opacity-0 bg-purple-700 text-white text-xs p-1">
                                        {subject.subjectTypeName}
                                      </span>
                                    ) : (
                                      <span className="mt-1 w-4 h-4 flex items-center justify-center inline-block w-5 h-5  rounded ring-1 ring-inset ring-yellow-300 ring-opacity-0 bg-yellow-700 text-white text-xs p-1">
                                        {subject.subjectTypeName}
                                      </span>
                                    )}
                                  </div>

                                  <Menu
                                    as="div"
                                    className="relative flex justify-end items-center"
                                  >
                                    <Menu.Button className="h-7 bg-white inline-flex items-center justify-center text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bg-primary-color">
                                      <span className="sr-only">
                                        Open options
                                      </span>
                                      <DotsVerticalIcon
                                        className="w-5 h-5"
                                        aria-hidden="true"
                                      />
                                    </Menu.Button>

                                    <Transition
                                      as={Fragment}
                                      enter="transition ease-out duration-100"
                                      enterFrom="transform opacity-0 scale-95"
                                      enterTo="transform opacity-100 scale-100"
                                      leave="transition ease-in duration-75"
                                      leaveFrom="transform opacity-100 scale-100"
                                      leaveTo="transform opacity-0 scale-95"
                                    >
                                      <Menu.Items className="mx-3 origin-top-right absolute right-7 top-0 w-48 mt-1 rounded-md shadow-lg z-10 bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none">
                                        <div className="py-1">
                                          <AllowedTo
                                            perform={Permissions.subject_modify}
                                          >
                                            <Menu.Item>
                                              {({ active }) => (
                                                <a
                                                  onClick={() => {
                                                    handleAddProduct(
                                                      subject.subjectId,
                                                      subject.name
                                                    );
                                                    setSellableProducts(
                                                      subject.sellableProducts
                                                    );
                                                  }}
                                                  className={classNames(
                                                    active
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    `  group flex items-center px-4 py-2 text-sm`
                                                  )}
                                                >
                                                  <AddIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer text-gray-400 hover:text-secondary-color transaction ease-in-out duration-300" />
                                                  Sellable Product
                                                </a>
                                              )}
                                            </Menu.Item>
                                          </AllowedTo>

                                          <AllowedTo
                                            perform={Permissions.subject_modify}
                                          >
                                            <Menu.Item>
                                              {({ active }) => (
                                                <a
                                                  onClick={(e) => {
                                                    handleCloneSubject(
                                                      subject.subjectId,
                                                      subject.name,
                                                      subject.subjectTypeId
                                                    );
                                                  }}
                                                  className={classNames(
                                                    active
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    `${
                                                      subject.subjectTypeId == 1
                                                        ? ""
                                                        : "hidden"
                                                    } group flex items-center px-4 py-2 text-sm`
                                                  )}
                                                >
                                                  <CopyIcon
                                                    title="Clone this subject"
                                                    className="mr-3 h-5 w-5 cursor-pointer text-gray-400"
                                                  />
                                                  Clone Subject
                                                </a>
                                              )}
                                            </Menu.Item>
                                          </AllowedTo>

                                          <AllowedTo
                                            perform={Permissions.subject_modify}
                                          >
                                            <Menu.Item>
                                              {({ active }) => (
                                                <a
                                                  onClick={(e) => {
                                                    redirectToSubjectDetail(
                                                      subject.subjectId,
                                                      parseInt(
                                                        subject.subjectTypeId
                                                      )
                                                    );
                                                  }}
                                                  className={classNames(
                                                    active
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "group flex items-center px-4 py-2 text-sm"
                                                  )}
                                                >
                                                  <EditIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300" />
                                                  Edit
                                                </a>
                                              )}
                                            </Menu.Item>
                                          </AllowedTo>
                                        </div>

                                        <AllowedTo
                                          perform={Permissions.subject_delete}
                                        >
                                          <div className="py-1">
                                            <Menu.Item>
                                              {({ active }) => (
                                                <a
                                                  onClick={(e) =>
                                                    deleteSubjectHandler(
                                                      e,
                                                      subject.subjectId
                                                    )
                                                  }
                                                  className={classNames(
                                                    active
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "group flex items-center px-4 py-2 text-sm"
                                                  )}
                                                >
                                                  <DeleteIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300" />
                                                  Delete
                                                </a>
                                              )}
                                            </Menu.Item>
                                          </div>
                                        </AllowedTo>
                                      </Menu.Items>
                                    </Transition>
                                  </Menu>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div
                  className={`flex justify-between items-center ${
                    newSubject.length === 0 ? "hidden" : ""
                  }`}
                >
                  <Pagination
                    pages={totalPages}
                    setPageNumber={setPageNumber}
                    ref={paginationRef}
                  />

                  <span>
                    <span className="text-sm pr-4 ml-auto text-left-700">
                      Showing {pageNumber} to{" "}
                      {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                      {totalRecords} results
                    </span>

                    <SelectPageSize
                      setPageSize={setPageSize}
                      type={"second"}
                      ref={pageSizeRef}
                      defaultPage={defaultPageSize}
                    />
                  </span>
                </div>

                {newSubject.length === 0 && (
                  <p className="p-2">No Records Found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

export default Subject;
